 const subscribeToTolstoyAddToCartClick = () => {
    const myCallback = (payload) => {
      // Your logic here
      window.updateMiniCart();
      // Open the mini cart 
      document.querySelector('header nav cart-mini-trigger').click();
      // Close the tolstoy modal
      let tolstoyModalMinimizeButtons = document.querySelectorAll('.minimize-tolstoy-modal');
      tolstoyModalMinimizeButtons.forEach((button) => {
        button.click();
      });
    };

    const options = {};

    window.tolstoyWidget.subscribe("tolstoy_add_to_cart", myCallback, options);
  };

  if (window.tolstoyWidget) {
    subscribeToTolstoyAddToCartClick();
  } else {
    window.addEventListener("tolstoyWidgetReady", () => {
      subscribeToTolstoyAddToCartClick();
      // Additional logic...
    });
  }